/** @jsx jsx */
import { jsx, Grid, Container } from "theme-ui";
import { graphql, useStaticQuery } from "gatsby";

import PageSection from "./PageSection";
import PageSectionHeading from "./PageSectionHeading";
import { BlogPostExtractS } from "./BlogPostExtract";

const Articles = ({title, exclude}) => {

  const data = useStaticQuery(graphql`{
    allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "//blog/articles//"}}
      sort: {frontmatter: {date: DESC}}
      limit: 5
    ) {
      edges {
        node {
          id
          excerpt(format: HTML)
          fields {
            slug
          }
          frontmatter {
            title
            image {
              childImageSharp {
                gatsbyImageData(quality: 90, width: 480, layout: CONSTRAINED)
              }
              publicURL
            }
            alt
          }
        }
      }
    }
  }`);

  // Make sure there's never more than 4 posts in the list to render.
  const posts = data.allMarkdownRemark.edges
    .filter(p => p.node.id !== exclude)
    .slice(0, 4);
  
  return (
    <PageSection>
      <Container>
        <PageSectionHeading title={title} />
        <Grid columns={[1, 2, 3]} gap={[7, 6, 7]}>
          {posts.map(({ node }, index) => (
            <BlogPostExtractS
              key={node.fields.slug}
              slug={node.fields.slug}
              image={node.frontmatter.image}
              alt={node.frontmatter.alt || "Illustrative image for the blog post"}
              title={node.frontmatter.title || node.fields.slug}
              excerpt={node.excerpt}
              sx={{
                // Only show the 4th post if we're in a 2x2 grid
                display: index === 3 ? ["none", "block", "none"] : "block"
              }}
            />
          ))}
        </Grid>
      </Container>
    </PageSection>
  );
};

export default Articles;
